const features = [
  {
    icon: 'ri-draft-line',
    title: 'Custom Lease Drafting',
    description:
      'Every lease is tailored to the specific property and tenancy, incorporating all necessary legal protections and owner preferences.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Renewal Coordination',
    description:
      'We proactively manage lease renewals, negotiating favorable terms and ensuring continuity with quality tenants.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Compliance Oversight',
    description:
      'Continuous monitoring of local and state regulations to ensure your lease agreements remain fully compliant at all times.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Rent Collection & Reporting',
    description:
      'Timely rent collection with detailed financial reporting, giving you complete visibility into your property\'s performance.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Documentation Management',
    description:
      'Secure storage and management of all lease documents, addenda, and correspondence throughout the tenancy lifecycle.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Tenant Relations',
    description:
      'Professional, responsive communication with tenants to maintain positive relationships and minimize disputes.',
  },
];

export default function LeaseManagement() {
  return (
    <section id="lease-management" className="w-full bg-[#FAF9F7] py-28 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-24 mb-16">
          <div className="md:w-1/3">
            <span className="text-xs uppercase tracking-[0.25em] text-[#8B7355] font-semibold">
              — Lease Management
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#1A1A1A] mt-5 leading-tight">
              Every Lease, Perfectly Managed
            </h2>
          </div>
          <div className="md:w-2/3 flex items-end">
            <p className="text-[#5A5A5A] text-base md:text-lg font-light leading-relaxed">
              From initial drafting to final move-out, we oversee every aspect of the lease lifecycle with precision, protecting your interests at every stage.
            </p>
          </div>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-lg p-8 border border-[#E8E6E3] hover:border-[#C9A961] transition-colors duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FAF9F7] mb-5 group-hover:bg-[#C9A961]/10 transition-colors duration-300">
                <i className={`${feature.icon} text-lg text-[#8B7355]`}></i>
              </div>
              <h3 className="text-base font-semibold text-[#1A1A1A] mb-3">{feature.title}</h3>
              <p className="text-sm text-[#6B6B6B] font-light leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
